import { render, staticRenderFns } from "./privacy-agreement.vue?vue&type=template&id=c701ac34&scoped=true"
import script from "./privacy-agreement.vue?vue&type=script&lang=js"
export * from "./privacy-agreement.vue?vue&type=script&lang=js"
import style0 from "./privacy-agreement.vue?vue&type=style&index=0&id=c701ac34&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c701ac34",
  null
  
)

export default component.exports